module.exports = __webpack_public_path__ + "static/media/orders-cash.7505e514.svg";